module.exports = __webpack_public_path__ + "static/media/interested-in-course-bg.753ddd9b.jpg";